var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphonesHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music-Audio / Headphones / headphones-human"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headphones-human"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4627 27.35C18.8221 27.35 14.2496 22.7775 14.2496 17.1369C14.2496 11.4964 18.8221 6.92383 24.4627 6.92383C30.1032 6.92383 34.6758 11.4964 34.6758 17.1369C34.6758 22.7775 30.1032 27.35 24.4627 27.35Z",
    stroke: "#448B7E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2734 21.2524C22.2359 21.2524 19.7734 18.79 19.7734 15.7524C19.7734 12.7149 22.2359 10.2524 25.2734 10.2524C28.311 10.2524 30.7734 12.7149 30.7734 15.7524C30.7734 18.79 28.311 21.2524 25.2734 21.2524Z",
    stroke: "#448B7E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2066 16.3886C25.2463 16.3886 24.4679 15.6101 24.4679 14.6499C24.4679 13.6896 25.2463 12.9111 26.2066 12.9111C27.1669 12.9111 27.9453 13.6896 27.9453 14.6499C27.9453 15.6101 27.1669 16.3886 26.2066 16.3886Z",
    fill: "#448B7E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.1492 40.6217V32.9217C37.9602 29.5798 41.168 23.0511 40.2622 16.4091C39.3565 9.76713 34.5178 4.33562 28.0242 2.67168C28.0242 2.67168 26.0002 2 23.8991 2C21.798 2 19.7741 2.51001 19.7741 2.51001C12.6571 3.95834 7.39911 9.40151 7.39911 15.8933V17.2683L4.06428 22.2715C3.56762 23.0156 3.46396 23.9548 3.78638 24.7893C4.1088 25.6238 4.81701 26.2493 5.68495 26.4662L7.39911 26.8933V31.4015C7.39914 33.0185 8.11071 34.5535 9.34465 35.5985C10.5786 36.6435 12.2099 37.0926 13.8048 36.8263L15.6491 36.5183V40.625",
    stroke: "#3F2C26",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesHuman);
export default __webpack_public_path__ + "static/media/headphones-human.ad41bb40be9297d33cb27c1d9de26bef.svg";
export { ForwardRef as ReactComponent };